import React, { useState } from 'react';
import './style.css'
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { InputMask } from 'primereact/inputmask';
import { getPolicyBuyInfo } from './buyapi';
import { useDispatch, useSelector } from 'react-redux';
import { selectIdPoliceL, selectIdPoliceP, selectInsuranceCompanyLife, selectInsuranceCompanyProperty, selectLinkPayPari, selectNumPolicyPari, selectPhone, selectShowChangeField, selectSumFinalL, selectSumFinalP, selectWaitFinalCalc, setIdPoliceL, setIdPoliceP, setInsuranceCompany, setInsuranceCompany2, setLinkPayPari, setPhone, setSumFinalL, setSumFinalP } from '../calc/calcSlice';

import { MAIN_ROUTE } from '../../static/vars';
import { getStatusPayPari } from '../calc/calcApi';
import { printPari } from '../personal/personapi';
import { selectLifeOption, selectPropertyOption, setLifeOption, setPropertyOption } from '../precalc/precalcSlice';
import NextBtn from '../calc/nextBtn';
import { PoliceCard } from '../calc/buy/policeCard';
import { setNumberContract, setStringDateBegin, setStringDateContract } from '../calc/contractSlice';
import { setBirthDateString, setIssuedBy, setLastname, setName, setPatronymic, setRegAdr, setSerial, setSex, setSubdivision } from '../calc/personSlice';
import { setAddresObject, setYearBuild } from '../calc/objectSlice';
import { PoliceCardOneB } from '../calc/buy/policeCardOneB';
// import { PoliceCardOneB } from '../calc/buy/policeCardOneB';

export function Buy(props) {
    let { id } = useParams();

    const [companyProp, setCompanyProp] = useState('');
    const [companyLife, setCompanyLife] = useState('');

    const dispatch = useDispatch()

    const sumFinalP = useSelector(selectSumFinalP)
    const sumFinalL = useSelector(selectSumFinalL)



    const waitFinalCalc = useSelector(selectWaitFinalCalc)

    const insuranceCompanyProperty = useSelector(selectInsuranceCompanyProperty)
    const insuranceCompanyLife = useSelector(selectInsuranceCompanyLife)
    const lifeOption = useSelector(selectLifeOption)
    const propertyOption = useSelector(selectPropertyOption)

    const isTwoPoliciesOnePari = lifeOption && propertyOption && (
        companyProp === 'ПАРИ' || companyLife === 'ПАРИ'
    )

    const isTwoPolices = lifeOption && propertyOption


    const [isBuy, setIsBuy] = useState(false);

    const [showPayPariWindow, setShowPayPariWindow] = useState(false);

    const [waitPay, setWaitPay] = useState(false);
    const [waitPayPari, setWaitPayPari] = useState(false);
    const [isPayPari, setIsPayPari] = useState(false);
    const [isPay, setIsPay] = useState(false);
    const [isPay2, setIsPay2] = useState(false);
    const showChangeField = useSelector(selectShowChangeField);


    const linkPayPari = useSelector(selectLinkPayPari)
    const idPoliceP = useSelector(selectIdPoliceP)
    const idPoliceL = useSelector(selectIdPoliceL)

    const phone = useSelector(selectPhone)

    const num_policy_pari = useSelector(selectNumPolicyPari)

    let payInterval;
    let payIntervalPari;

    const handleChangePhone = (e) => {
        dispatch(setPhone(e.target.value))
    }

    const openPdfPolicy = (url) => {
        const newWin = window.open(url, '_blank', 'width=1000,height=800');
    };

    const handleGetPdfPolicy = (isn, path, company_id) => {
        console.log('handleGetPdfPolicy ', isn, path, company_id);

        let url = '';

        if (path === 'z') {
            url = `https://c61437.na4u.ru/static/policies_zetta/${isn}.pdf`;
        } else if (path === 'p' || company_id === 3) {
            printPari({ isn: isn }, (data) => {
                console.log('printPari', data);
                url = `https://c61437.na4u.ru/static/policies_pari/${data.res}.pdf`;
                openPdfPolicy(url);
            });
            return; // Exit the function early, as the PDF is opened asynchronously.
        } else if (company_id === 4) {
            url = `https://c61437.na4u.ru/static/policies_vsc/${path}.pdf`;
        } else if (path !== '') {
            url = `https://c61437.na4u.ru/static/policies/${path}.pdf`;
        }

        openPdfPolicy(url);
    };


    const handleDownload = () => {
        getStatusPayPari({ num_policy_pari: idPoliceP }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
                handleGetPdfPolicy(idPoliceP, data.path, 1)
            }
        })
    }

    const handleDownloadL = () => {
        getStatusPayPari({ num_policy_pari: idPoliceL }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
                handleGetPdfPolicy(idPoliceL, data.path, 1)
            }
        })
    }

    const handleDownloadPari = () => {

        console.log('handleDownloadPari', companyLife === 'ПАРИ' ? idPoliceL: idPoliceP)
        getStatusPayPari({ num_policy_pari: idPoliceL }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
                handleGetPdfPolicy(idPoliceL, data.path, 3)
            }
        })
    }

    const handleGetStatusPay = () => {
        getStatusPayPari({ num_policy_pari: idPoliceP }, (data) => {
            console.log('getStatusPay', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPay(false)
                setIsPay(true)
                clearInterval(payInterval)
                payInterval = null
            }
        })

    }

    const handleGetStatusPayPari = () => {

        getStatusPayPari({ num_policy_pari: num_policy_pari }, (data) => {
            console.log('getStatusPayPari', data)
            if (data.res) {
                console.log('stop interval')
                setWaitPayPari(false)
                setIsPayPari(true)
                clearInterval(payIntervalPari)
                payIntervalPari = null
            }
        })

    }

    const handlePayDomStrah = () => {
        setIsBuy(true)
        clearInterval(payInterval)
        dispatch(setLinkPayPari(MAIN_ROUTE + `/pay/${idPoliceP || '0'}/${idPoliceL || '0'}/${sumFinalP || '0'}/${sumFinalL || '0'}`))
        setShowPayPariWindow(true)
        if (!payInterval) payInterval = setInterval(handleGetStatusPay, 5000)
    }

    const handlePayPari = () => {
        setIsBuy(true)
        clearInterval(payIntervalPari)
        setShowPayPariWindow(true)
        setWaitPayPari(true)



        if (!payIntervalPari) payIntervalPari = setInterval(handleGetStatusPayPari, 5000)
    }

    useEffect(() => {
        getPolicyBuyInfo({ id: id }, (data) => {
            console.log('getPolicyBuyInfo', data)

            if (data.redirect) dispatch(setLinkPayPari(data.redirect))

            if (data.policies.length > 1) {
                dispatch(setPropertyOption(true))
                dispatch(setLifeOption(true))
                setCompanyLife(data.policies[1].company_id === 3 ? 'ПАРИ' : (data.policies[1].company_id === 2 ? 'Зетта Страхование' : (data.policies[1].company_id === 4 ? 'ВСК' : 'Абсолют')))
                dispatch(setSumFinalL(data.policies[1].payment_amount))
                dispatch(setIdPoliceL(data.policies[1].policy_number))
                setIsPay2(data.policies[1].pay_status === 1)
                setIsPay(data.policies[0].pay_status === 1)
            }

            if (data.policies.length > 0) {
                if (data.policies[0].type === 'Жизнь') {
                    dispatch(setLifeOption(true))
                    dispatch(setSumFinalL(data.policies[0].payment_amount))
                    dispatch(setIdPoliceL(data.policies[0].policy_number))
                    setCompanyLife(data.policies[0].company_id === 3 ? 'ПАРИ' : (data.policies[0].company_id === 2 ? 'Зетта Страхование' : (data.policies[0].company_id === 4 ? 'ВСК' : 'Абсолют')))
                }
                else {
                    dispatch(setPropertyOption(true))
                    dispatch(setSumFinalP(data.policies[0].payment_amount))
                    dispatch(setIdPoliceP(data.policies[0].isn))
                    setCompanyProp(data.policies[0].company_id === 3 ? 'ПАРИ' : (data.policies[0].company_id === 2 ? 'Зетта Страхование' : (data.policies[0].company_id === 4 ? 'ВСК' : 'Абсолют')))
                }

                setIsPay(data.policies[0].pay_status === 1)

                dispatch(setNumberContract(data.policies[0].agr_credit_number))
                dispatch(setStringDateContract(data.policies[0].agr_credit_date_conc.slice(0, 10)))
                dispatch(setStringDateBegin(data.policies[0].date_begin))
                dispatch(setName(data.policies[0].firstname))
                dispatch(setLastname(data.policies[0].lastname))
                dispatch(setPatronymic(data.policies[0].parentname))
                dispatch(setBirthDateString(data.policies[0].birthday.slice(0, 10)))
                dispatch(setSerial(data.policies[0].series_doc + ' ' + data.policies[0].number_doc))
                dispatch(setIssuedBy(data.policies[0].issue_by))
                dispatch(setRegAdr(data.policies[0].addres_holder_reg))
                dispatch(setSex(data.policies[0].sex))
                dispatch(setAddresObject(data.policies[0].addres_object))
                dispatch(setYearBuild(data.policies[0].year_build))
                dispatch(setSubdivision(data.policies[0].div_code))


            }
        })
    }, []);

    return (
        <div class="section-calculator-tab-body calculator-tab-body-4 ">
            <div class="calculator-tab-body-blok calculator-tab-body-blok-1">
                <p class="calculator-tab-body-blok-title calculator-tab-body-blok-title-301">Ваш полис
                </p>
                <div class="tab-body-blok-contant-401">
                    {showChangeField &&
                        <div class="tab-body-blok-contant-401-up">
                            <div class="tab-body-blok-info-403">
                                <p
                                    class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                    Обязательное требование данных страховых компаний— оплата строго по
                                    очереди.
                                    После оплаты данные придут на почту указанную ранее.</p>
                            </div>
                            <div class="tab-body-blok-info-400">
                                <div class="tab-body-blok-info-element tab-body-blok-info-element-400">
                                    <div class="tab-body-blok-info-element-vnutr">
                                        <label class="section-two-banks-text-2" for="pet-select">Мобильный
                                            телефон</label>
                                        <InputMask mask="+7(999) 999-9999"
                                            placeholder="+7(___) ___-____"
                                            className="pole pole-step-2 mask-phone "
                                            value={phone}
                                            onChange={handleChangePhone}
                                        />
                                    </div>
                                </div>
                                <p
                                    class="tab-body-blok-info-animation-text tab-body-blok-info-animation-text-2 tab-body-blok-info-element-400-text">
                                    Страховая компания не принимает текущий номер телефона. Пожалуйста,
                                    укажите
                                    новый номер или оформите заявку с помощью нашего менеджера.</p>
                                {/* <div class="button button-1 button-novostroiki-1 button-step-2 button-step-400"
                                    >
                                        Оформить
                                    </div> */}
                                <NextBtn
                                    text={'Изменить'}
                                    checkOne={true}
                                    checkTwo={true}
                                    checkThree={true}
                                    checkFour={true}
                                    setShowAlertForUser={() => { }}
                                    check={false}

                                />
                            </div>
                        </div>
                    }
                    {waitFinalCalc &&
                        <div class="blok-info-animation">
                            <div class="circle-box" id="circle-box">
                                <div class="circle circle-1 slideInDown wow"></div>
                                <div class="circle circle-2 slideInDown wow"></div>
                                <div class="circle circle-3 slideInDown wow"></div>
                            </div>
                        </div>
                    }



                    {
                        !waitFinalCalc && (
                            <>
                                {isTwoPoliciesOnePari ? (
                                    <>
                                        <PoliceCardOneB
                                            is_buy={isPay}
                                            setShowPayPariWindow={setShowPayPariWindow}
                                            insurance={companyProp}
                                            sum={sumFinalP}
                                            waitPay={companyProp === 'ПАРИ' ? waitPayPari : waitPay}
                                            setWaitPay={companyProp === 'ПАРИ' ? setWaitPayPari : setWaitPay}
                                            handlePay={companyProp === 'ПАРИ' ? handlePayPari : handlePayDomStrah}
                                            handleDownload={companyProp === 'ПАРИ' ? handleDownloadPari : handleDownload}
                                        />
                                        <PoliceCardOneB
                                            is_buy={isPay2}
                                            setShowPayPariWindow={setShowPayPariWindow}
                                            insurance={companyLife}
                                            sum={sumFinalL}
                                            waitPay={companyLife === 'ПАРИ' ? waitPayPari : waitPay}
                                            setWaitPay={companyLife === 'ПАРИ' ? setWaitPayPari : setWaitPay}
                                            handlePay={companyLife === 'ПАРИ' ? handlePayPari : handlePayDomStrah}
                                            handleDownload={companyLife === 'ПАРИ' ? handleDownloadPari : handleDownload}
                                        />
                                    </>
                                ) : (
                                    // Варианты для isTwoPolices
                                    <>
                                        {isTwoPolices ? (

                                            <>
                                                <PoliceCard
                                                    insurance={companyProp}
                                                    sum={sumFinalP}
                                                    type={'Имущество'}
                                                    selfManager={idPoliceP === 'manager'}
                                                    otherManager={idPoliceL === 'manager'}
                                                    isPay={isPay}
                                                    handleDownload={handleDownload}
                                                />
                                                <PoliceCard
                                                    insurance={companyLife}
                                                    sum={sumFinalL}
                                                    type={'Жизнь'}
                                                    selfManager={idPoliceL === 'manager'}
                                                    otherManager={idPoliceP === 'manager'}
                                                    isPay={isPay}
                                                    handleDownload={handleDownloadL}
                                                />
                                            </>
                                        ) : (

                                            <>
                                                <PoliceCard
                                                    insurance={companyProp}
                                                    sum={sumFinalP}
                                                    type={'Имущество'}
                                                />
                                            </>
                                        )}
                                        {!isPay && <div class="button button-1 button-novostroiki-1 button-step-401"
                                            onClick={isPay ?
                                                (
                                                    (companyProp === 'ПАРИ' || companyLife === 'ПАРИ') ?
                                                        handleDownloadPari :
                                                        handleDownload
                                                ) :

                                                (
                                                    (companyProp === 'ПАРИ' || companyLife === 'ПАРИ') ?
                                                        handlePayPari :
                                                        handlePayDomStrah
                                                )
                                            }
                                        >
                                            {
                                                isPay ? 'Скачать' :
                                                    isBuy ? 'Ожидание' : 'Перейти к оплате1'
                                            }
                                        </div>}
                                    </>
                                )}
                            </>
                        )
                    }



                    {
                        showPayPariWindow &&
                        <div className='cntr_iframe'>
                            <div className='btn btn-secondary' onClick={() => setShowPayPariWindow(false)}>Закрыть</div>
                            <iframe title='pay' className='iframe_pay' src={linkPayPari}>

                            </iframe>
                        </div>
                    }

                </div>
            </div>
        </div>
    )
}